import { render, staticRenderFns } from "./FaqAndContactSection.vue?vue&type=template&id=a93be97e&scoped=true&"
import script from "./FaqAndContactSection.vue?vue&type=script&lang=js&"
export * from "./FaqAndContactSection.vue?vue&type=script&lang=js&"
import style0 from "./FaqAndContactSection.vue?vue&type=style&index=0&id=a93be97e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93be97e",
  null
  
)

export default component.exports